// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-D":"D_power-ocean-collection-D__IgqHa"};